"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";

import { isSensitivePaymentPath } from "@/lib/sensitive-route-policy";

// Routes that render as bare, single-decision app surfaces. /cart gets only a
// minimal "Secure checkout" header (see app/cart/layout.tsx); /chat gets its
// own slim consultation header. Global navigation, breadcrumbs, footer, mobile
// bottom bar, and the sticky global chat CTA would compete with both surfaces.
const BARE_CHROME_PREFIXES = ["/cart", "/chat"];

function isBareChrome(pathname: string | null): boolean {
  if (!pathname) return false;
  if (isSensitivePaymentPath(pathname)) return true;
  return BARE_CHROME_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

export function ChromeGate({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  if (isBareChrome(pathname)) return null;
  return <>{children}</>;
}
